import React from 'react';
import {
  Button,
  Flex,
  IButtonProps,
  Stack,
} from '@grubhubprod/gh-cookbook-react/dist';
import { SvgExternalLink } from '@grubhubprod/gh-cookbook-react';

export interface BalanceOnboardingButtonProps extends IButtonProps {
  text: string;
}

export function BalanceOnboardingButton({
  text,
  href,
  disabled,
  ...props
}: BalanceOnboardingButtonProps): JSX.Element {
  return (
    <Button
      variant="primary"
      buttonSize="medium"
      as="a"
      href={href}
      disabled={disabled}
      {...props}
    >
      <Flex alignItems="center" justifyContent="center" height="100%">
        <Stack x="x-sm" alignItems="center">
          {text}
        </Stack>
        <SvgExternalLink size="16px" />
      </Flex>
    </Button>
  );
}
